import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

type State = "checking" | "authed" | "anon";

export default function RequireOwner({ children }: { children: ReactNode }) {
  const [state, setState] = useState<State>("checking");

  useEffect(() => {
    let cancelled = false;
    api.admin
      .session()
      .then((s) => {
        if (cancelled) return;
        setState(s.authenticated ? "authed" : "anon");
      })
      .catch(() => {
        if (cancelled) return;
        setState("anon");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") return null;
  if (state === "anon") return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}
